import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M26 2.5V3.5C26 3.83333 25.8333 4 25.5 4H20L14 28H19.5C19.8333 28 20 28.1667 20 28.5V29.5C20 29.8333 19.8333 30 19.5 30H6.5C6.16667 30 6 29.8333 6 29.5V28.5C6 28.1667 6.16667 28 6.5 28H12L18 4H12.5C12.1667 4 12 3.83333 12 3.5V2.5C12 2.16667 12.1667 2 12.5 2H25.5C25.8333 2 26 2.16667 26 2.5Z'],
  name: 'uiItalic',
  oldName: 'falItalic'
} as IconDefinition
